export const ROOT_FOLDER_PATH = '';
export const PATH_SEPARATOR = '/';
